import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { DbService } from 'src/app/services/db/db.service';

@Component({
  selector: 'app-ficha-tecnica',
  templateUrl: './ficha-tecnica.component.html',
  styleUrls: ['./ficha-tecnica.component.scss'],
})
export class FichaTecnicaComponent implements OnInit {
  data
  desInicio;
  allFichasData;
  @Input() dataF: any;
  @Input() sesion: any;
  slidesOptions
  microCiclos: Observable<any>;
  constructor(private modalController: ModalController, private dbservice: DbService) {
    
   this.microCiclos = this.dbservice.getMicrociclos();
   this.slidesOptions = {
    initialSlide: this.sesion,
    direction: 'horizontal',
    slidesPerView: 4,
  };
  } 

  ngOnInit() {
    this.data = this.dataF;
    console.log(this.sesion)
  }

  closeModal() {
    this.modalController.dismiss();
  }

}


// for(let i = 0; i < Array.from(el.split(",")).length;i++){console.log(Array.from(el.split(","))[i])}
